export default __webpack_public_path__ + "static/media/coast.37a00d25.svg";